import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import HeroSimple from "./sections/HeroSimple";
import Historia from "./sections/Historia";
import Valores from "./sections/Valores";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <HeroSimple />
      <Historia />
      <Valores />
      <Footer />
    </div>;
}